import axios from 'axios';
import React, { useState, useRef,useEffect } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation,Trans  } from 'react-i18next';
import { endPoints } from "../../Constants";

const Callback = () => {
    const initialValues = { Category: "", FullName: "", Email: "", PhoneNumber: "", ContactReason: "", File: "" };
    const [formValues, setFormValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { t,ready,i18n  } = useTranslation();
    const [fileName, setFileName] = useState(t('noFileSelected'));
    const fileInputRef = useRef(null);

    useEffect(() => {
    if (ready) {
        setFileName(t('noFileSelected'));
    }
    }, [ready, t]);

    const validateForm = () => {
        const errorMessages = {};
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        const phoneRegex = /^\+91\d{10}$/;

        if (!formValues.Category) {
            errorMessages.Category = "Category is required.";
            errorMessages.CategoryMr = "कृपया श्रेणी निवडा.";
        }
        if (!formValues.FullName) {
            errorMessages.FullName = "Full Name is required.";
            errorMessages.FullNameMr = "पूर्ण नाव आवश्यक आहे.";
        } else if (!/^[a-zA-Z\s]+$/.test(formValues.FullName)) {
            errorMessages.FullName = "Full Name can only contain letters and spaces.";
            errorMessages.FullNameMr = "पूर्ण नावामध्ये केवळ अक्षरे आणि रिकाम्या जागा असाव्यात.";
        }
        if (!formValues.Email) {
            errorMessages.Email = "Email is required.";
            errorMessages.EmailMr = "कृपया ईमेल प्रविष्ट करा.";
        } else if (!emailRegex.test(formValues.Email)) {
            errorMessages.Email = "Please enter a valid email address.";
            errorMessages.EmailMr = "कृपया वैध ईमेल पत्ता प्रविष्ट करा.";
        }
        if (!formValues.PhoneNumber) {
            errorMessages.PhoneNumber = "Phone Number is required.";
            errorMessages.PhoneNumberMr = "कृपया फोन नंबर प्रविष्ट करा.";
        } else if (!phoneRegex.test(formValues.PhoneNumber)) {
            errorMessages.PhoneNumber = "Please enter a valid phone number starting with +91.";
            errorMessages.PhoneNumberMr = "कृपया +91 ने सुरू होणारा वैध फोन नंबर प्रविष्ट करा.";
        }

        return errorMessages;
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Access the selected file
        setFileName(e.target.files[0]?.name || t('noFileSelected'));
        if (!file) {
            setErrors((prevErrors) => ({ ...prevErrors, File: null }));
            return;
        }

        const allowedTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedTypes.includes(file.type)) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                File: "Only PDF, DOC, and DOCX files are allowed.",
            }));
            fileInputRef.current.value = ""; // Reset invalid file
            return;
        }

        // Store the file in the state
        setFormValues((prevValues) => ({
            ...prevValues,
            File: file,
        }));

        // Clear errors if the file is valid
        setErrors((prevErrors) => ({ ...prevErrors, File: null }));
    };


    const resetForm = () => {
        setFormValues(initialValues);
        setErrors({});
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Reset file input field
        }
    };

    const submitHandler = async (event) => {
        event.preventDefault();
    
        setIsLoading(true);

        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            setIsLoading(false);
            return;
        }

        const { Category, FullName, Email, PhoneNumber, ContactReason, File } = formValues;
        const MSG = "Sample message"; // Default or dynamic value
        const IpAddr = "127.0.0.1"; // Replace with a dynamic fetch if necessary

        // Prepare JSON data for the "data" field
        const jsonData = {
            Category,
            FullName,
            Email,
            PhoneNumber,
            ContactReason,
            MSG,
            IpAddr,
        };

        // Create a FormData object
        const formData = new FormData();
        formData.append("data", JSON.stringify(jsonData)); // Append JSON as a string

        // Append the file if available
        if (File) {
            formData.append("File", File); // File field
        }

        const token = localStorage.getItem("token");
        if (!token) {
            alert("User is not authenticated. Token is missing.");
            setIsLoading(false);
            return;
        }

        try {
            const response = await axios.post(`${endPoints.entry}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            if(response.status === 200)
            {
                setShowModal(true);
                resetForm();
                console.log("Response:", response.data); // Log successful response
            }
            else
            {
                console.log("Response:", response.data); // Log successful response
            }
        } catch (err) {
            console.error("Error:", err.response || err.request || err.message);
            if (err.response) {
                alert(`Error: ${err.response.data.message || "Failed to submit form"}`);
            } else if (err.request) {
                alert("No response from server. Please try again later.");
            } else {
                alert("An error occurred while preparing the request.");
            }
        } finally {
            setIsLoading(false);
        }
    };





    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prevValues => ({ ...prevValues, [name]: value }));
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    return (
        <>
            <Modal show={showModal} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('callbackThankYou')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t('callbackThankYouMsg')}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleModalClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <section className='lyt-section typ-contect-sec custom-margin-top'>
                <div className='container'>
                    <div className='bs-breadcrumb'>
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">  {t('home')}</Breadcrumb.Item>
                            <Breadcrumb.Item active>  {t('contactUs')}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>

                    <div className='heading-wrapper w-100 d-block'>
                        <div className='text-center'>
                            <h2 className='bs-heading typdblue mb-2' data-aos="fade-in" data-aos-delay="200">
                                 {t('callbackTitle')}
                            </h2>
                            <p className='bs-para typgrey' data-aos="fade-in" data-aos-delay="300">
                               {t('callbackSubTitle')}
                            </p>
                        </div>
                    </div>
                </div>

                <div className='container-bg'>
                    <div className='form-wrapper container'>
                        <div className='row justify-content-center align-items-center'>
                            <div className='col-lg-4 col-md-6 col-12'>
                                <div className='leftBox'>
                                    <div className='imgBox'>
                                        <Image
                                            className="img-fluid"
                                            src="/images/contact/1.jpg"
                                            alt="logo"
                                            width={384}
                                            height={485}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-8 col-md-6 col-12 mt-lg-0 mt-md-0 mt-5'>
                                <div className='rightBox'>
                                    <Form className='bs-form-box' onSubmit={submitHandler}>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className='form-feilds'>
                                                    <Form.Group>
                                                        <Form.Label>{t('selectCategory')}<span>*</span></Form.Label>
                                                        <Form.Select name='Category' value={formValues.Category} onChange={handleChange}>
                                                            <option value="">{t('select')}</option>
                                                            <option value="Housing Societies">{t('callbackCategory1')}</option>
                                                            <option value="Tenanted Properties, Cessed Buildings">{t('callbackCategory2')}</option>
                                                            <option value="Proposed Societies (SRA)">{t('callbackCategory3')}</option>
                                                            <option value="Apartments">{t('callbackCategory4')}</option>
                                                        </Form.Select>
                                                        {errors.Category && <div className="text-danger">{i18n.language === 'mr' ? errors.CategoryMr : errors.Category}</div>}
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-6 col-12'>
                                                <div className='form-feilds'>
                                                    <Form.Group>
                                                        <Form.Label>{t('fullName')}<span>*</span></Form.Label>
                                                        <Form.Control type="text" placeholder={t('enterName')} name='FullName' value={formValues.FullName} onChange={handleChange} />
                                                        {errors.FullName && <div className="text-danger">{i18n.language === 'mr' ? errors.FullNameMr :errors.FullName}</div>}
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-12'>
                                                <div className='form-feilds'>
                                                    <Form.Group>
                                                        <Form.Label>{t('emailAddress')}<span>*</span></Form.Label>
                                                        <Form.Control type="email" placeholder={t('enterEmail')} name='Email' value={formValues.Email} onChange={handleChange} />
                                                        {errors.Email && <div className="text-danger">{i18n.language === 'mr' ? errors.EmailMr :errors.Email}</div>}
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-lg-6 col-12'>
                                                <div className='form-feilds'>
                                                    <Form.Group>
                                                        <Form.Label>{t('phoneNumber')}<span>*</span></Form.Label>
                                                        <Form.Control type="text" placeholder={t('enterPhoneNumber')} name='PhoneNumber' value={formValues.PhoneNumber} onChange={handleChange} />
                                                        {errors.PhoneNumber && <div className="text-danger">{i18n.language === 'mr' ? errors.PhoneNumberMr :errors.PhoneNumber}</div>}
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-12'>
                                                <div className='form-feilds'>
                                                    <Form.Group>
                                                        <Form.Label>{t('reasonToConnect')}</Form.Label>
                                                        <Form.Select name='ContactReason' value={formValues.ContactReason} onChange={handleChange}>
                                                            <option value="">{t('select')}</option>
                                                            <option value="Query related to registration">{t('callbackQuery1')}</option>
                                                            <option value="Query related to payment" >{t('callbackQuery2')}</option>
                                                            
                                                        </Form.Select>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className='form-feilds'>
                                                    <Form.Group>
                                                        <Form.Label>{t('uploadFiles')}</Form.Label>
                                                          <Form.Control 
                                                                type="text" 
                                                                value={fileName} 
                                                                readOnly 
                                                                onClick={() => fileInputRef.current.click()} 
                                                            />
                                                        <Form.Control
                                                            type="file"
                                                            name="File"
                                                            style={{display:'none'}}
                                                            ref={fileInputRef}
                                                            accept=".pdf,.doc,.docx" // Restrict file selection to specific formats
                                                            onChange={handleFileChange}
                                                        />
                                                        <Button className='ml-5' onClick={() => fileInputRef.current.click()}>{t('browse')}</Button>
                                                        {errors.file && <div className="text-danger">{errors.file}</div>}
                                                    </Form.Group>

                                                </div>
                                            </div>
                                        </div>

                                        <div className='text-lg-end'>
                                            <button
                                                type='submit'
                                                className="bs-btn typfill"
                                                aria-label="Navigate to Contact Us"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? "Submitting..." : t('submit')} <span className="icon icon-right-arrow"></span>
                                            </button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Callback;
